import { dataProps } from './properties'

export const setTailoringTrialTypeList = (state, payload) => {
    state.list = payload
}    

export const setTailoringTrialTypeData = (state, payload) => {
    state.props = payload
} 

export const resetTailoringTrialTypeData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringTrialType/mutations.js